import * as moment from 'moment-business-days'

moment.updateLocale('es', {
  holidays: [
    '2022-01-01',
    '2022-01-10',
    '2022-03-21',
    '2022-04-14',
    '2022-04-15',
    '2022-05-01',
    '2022-05-30',
    '2022-06-20',
    '2022-06-27',
    '2022-07-04',
    '2022-07-20',
    '2022-08-07',
    '2022-08-15',
    '2022-10-17',
    '2022-11-07',
    '2022-11-14',
    '2022-12-08',
    '2022-12-25',
    '2023-01-01',
    '2023-01-09',
    '2023-03-20',
    '2023-04-02',
    '2023-04-06',
    '2023-04-07',
    '2023-04-09',
    '2023-05-01',
    '2023-05-22',
    '2023-06-12',
    '2023-06-19',
    '2023-07-03',
    '2023-07-20',
    '2023-08-07',
    '2023-08-21',
    '2023-10-16',
    '2023-11-06',
    '2023-11-13',
    '2023-12-08',
    '2023-12-25',
    '2024-01-01',
    '2024-01-08',
    '2024-03-24',
    '2024-03-25',
    '2024-03-28',
    '2024-03-29',
    '2024-03-31',
    '2024-05-01',
    '2024-05-13',
    '2024-06-03',
    '2024-06-10',
    '2024-07-01',
    '2024-07-20',
    '2024-08-07',
    '2024-08-19',
    '2024-10-14',
    '2024-11-04',
    '2024-11-11',
    '2024-12-08',
    '2024-12-25',
    '2025-01-01',
    '2025-01-06',
    '2025-03-24',
    '2025-04-13',
    '2025-04-17',
    '2025-04-18',
    '2025-04-20',
    '2025-05-01',
    '2025-06-02',
    '2025-06-23',
    '2025-06-30',
    '2025-07-20',
    '2025-08-07',
    '2025-08-18',
    '2025-10-13',
    '2025-11-03',
    '2025-11-17',
    '2025-12-08',
    '2025-12-25',
    '2026-01-01',
    '2026-01-12',
    '2026-03-23',
    '2026-03-29',
    '2026-04-02',
    '2026-04-03',
    '2026-04-05',
    '2026-05-01',
    '2026-05-18',
    '2026-06-08',
    '2026-06-15',
    '2026-06-29',
    '2026-07-20',
    '2026-08-07',
    '2026-08-17',
    '2026-10-12',
    '2026-11-02',
    '2026-11-16',
    '2026-12-08',
    '2026-12-25',
    '2027-01-01',
    '2027-01-11',
    '2027-03-21',
    '2027-03-22',
    '2027-03-25',
    '2027-03-26',
    '2027-03-28',
    '2027-05-01',
    '2027-05-10',
    '2027-05-31',
    '2027-06-07',
    '2027-07-05',
    '2027-07-20',
    '2027-08-07',
    '2027-08-16',
    '2027-10-18',
    '2027-11-01',
    '2027-11-15',
    '2027-12-08',
    '2027-12-25',
    '2028-01-01',
    '2028-01-10',
    '2028-03-20',
    '2028-04-09',
    '2028-04-13',
    '2028-04-14',
    '2028-04-16',
    '2028-05-01',
    '2028-05-29',
    '2028-06-19',
    '2028-06-26',
    '2028-07-03',
    '2028-07-20',
    '2028-08-07',
    '2028-08-21',
    '2028-10-16',
    '2028-11-06',
    '2028-11-13',
    '2028-12-08',
    '2028-12-25',
    '2029-01-01',
    '2029-01-08',
    '2029-03-19',
    '2029-03-25',
    '2029-03-29',
    '2029-03-30',
    '2029-04-01',
    '2029-05-01',
    '2029-05-14',
    '2029-06-04',
    '2029-06-11',
    '2029-07-02',
    '2029-07-20',
    '2029-08-07',
    '2029-08-20',
    '2029-10-15',
    '2029-11-05',
    '2029-11-12',
    '2029-12-08',
    '2029-12-25',
    '2030-01-01',
    '2030-01-07',
    '2030-03-25',
    '2030-04-14',
    '2030-04-18',
    '2030-04-19',
    '2030-04-21',
    '2030-05-01',
    '2030-06-03',
    '2030-06-24',
    '2030-07-01',
    '2030-07-20',
    '2030-08-07',
    '2030-08-19',
    '2030-10-14',
    '2030-11-04',
    '2030-11-11',
    '2030-12-08',
    '2030-12-25',
    '2031-01-01',
    '2031-01-06',
    '2031-03-24',
    '2031-04-06',
    '2031-04-10',
    '2031-04-11',
    '2031-04-13',
    '2031-05-01',
    '2031-05-26',
    '2031-06-16',
    '2031-06-23',
    '2031-06-30',
    '2031-07-20',
    '2031-08-07',
    '2031-08-18',
    '2031-10-13',
    '2031-11-03',
    '2031-11-17',
    '2031-12-08',
    '2031-12-25'

  ],
  holidayFormat: 'YYYY-MM-DD',
  workingWeekdays: [1, 2, 3, 4, 5]
})

export default {
  install (Vue, options) {
    Vue.prototype.$moment = moment
  }
}
